import { Injectable } from '@angular/core';
import { RuntimeConfigService } from './runtime-config.service';

@Injectable()
export class EnvironmentUrlService {

    public riskApiAddress: string;

  constructor(private runtimeConfigService: RuntimeConfigService) {
    this.riskApiAddress = this.runtimeConfigService.getRiskApiAddress();
  }

}
